import Button from '../../../components/form-control/Button';
import Input from '../../../components/form-control/Input';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  updateRNPL
} from '../../../api/requests';

import {
  capitalizeSentence,
  getSelectOptionsFromEnum,
  showToast
} from '../../../utils/miscFunctions';
import { useState } from 'react';
import { REPAIR_TYPES } from '../../../resources/enums';
import SelectDropdown from '../../../components/form-control/SelectDropdown';
import TextArea from '../../../components/form-control/TextArea';

interface EditLeadProps {
  onProceed: () => void;
  onClose: () => void;
  rnplApplicant: any;
  section: string;
}

const EditLead = ({ onProceed, onClose, rnplApplicant, section }: EditLeadProps) => {
  const [loading, setLoading] = useState<boolean>(false);

  const isNotOtherRepairType = (repairType: string) => repairType in REPAIR_TYPES;

  return (
    <div className="">

      <Formik
        initialValues={{
          customerId: 0,
          vehicleId: 0,
          repairType: isNotOtherRepairType(rnplApplicant.repairType)
            ? String(rnplApplicant.repairType)
            : String(REPAIR_TYPES.OTHER),
          otherRepairType: isNotOtherRepairType(rnplApplicant.repairType)
            ? ''
            : capitalizeSentence(rnplApplicant.repairType),
          repairDescription: String(rnplApplicant.repairDescription),
          repairCost: String(rnplApplicant.repairCost),
          ownerConsent: true
        }}
        enableReinitialize={true}
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={Yup.object().shape({
          repairDescription: Yup.string().trim().required('Description is required.'),
          repairCost: Yup.number()
            .required('Repair Cost is required.')
            .positive('Repair Cost must be a positive number.')
            .max(5000, 'Repair Cost must be less than or equal to 5000.')
        })}
        onSubmit={(values) => {
          const payload: any = {
            customerId: rnplApplicant.customer.id,
            vehicleId: rnplApplicant.vehicles.id,
            repairType:
              values.repairType == REPAIR_TYPES.OTHER ? values.otherRepairType : values.repairType,
            repairDescription: values.repairDescription,
            repairCost: values.repairCost,
            ownerConsent: values.ownerConsent
          };

          const id = rnplApplicant.id;
          if (id) setLoading(true);
          updateRNPL(id, payload)
            .then((response: any) => {
              onProceed();
              showToast.success(response.message && 'RNPL updated successfully.');
            })
            .catch((error: any) => {
              showToast.error(error.description && 'Something went wrong');
            })
            .finally(() => setLoading(false));
        }}>
        {({
          values,
          errors,
          isSubmitting,
          handleSubmit,
          handleChange,
          handleBlur,
          setFieldValue,
          touched
        }) => (
          <form className="" onSubmit={handleSubmit}>
            <div className="p-8">
              <div className=" ">
                <div className="grid  grid-cols-1 md:grid-cols-1 gap-5  ">
                  <div
                    className={` ${
                      values.repairType == 'OTHER' &&
                      'rounded border flex flex-col space-y-8 p-3 border-gray-300'
                    }`}>
                    <SelectDropdown
                      name="repairType"
                      listSelectedValue={values.repairType}
                      onChange={(value: string) => {
                        setFieldValue('repairType', value);
                      }}
                      label="Repair Type"
                      placeholder="Select repair type"
                      list={getSelectOptionsFromEnum(REPAIR_TYPES)}
                      required
                      error={touched.repairType ? errors.repairType : undefined}
                      helperText={touched?.repairType ? errors.repairType : undefined}
                      selectInputClassName="rounded"
                    />

                    <TextArea
                      name="otherRepairType"
                      value={values.otherRepairType}
                      onChange={handleChange}
                      onBlur={handleChange}
                      placeholder="Provide any other type..."
                      required
                      error={touched.otherRepairType ? errors.otherRepairType : undefined}
                      helperText={touched?.otherRepairType ? errors.otherRepairType : undefined}
                      classes={`rounded ${values.repairType !== REPAIR_TYPES.OTHER && 'hidden'}`}
                    />
                  </div>
                  <div>
                    {' '}
                    <Input
                      type={'number'}
                      name="repairCost"
                      value={values.repairCost}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      label="Repair Cost"
                      placeholder="Enter repair cost"
                      required
                      error={touched.repairCost ? errors.repairCost : undefined}
                      helperText={touched?.repairCost ? errors.repairCost : undefined}
                      className="rounded"
                    />
                  </div>

                  <div>
                    {' '}
                    <TextArea
                      name="repairDescription"
                      value={values.repairDescription}
                      onChange={handleChange}
                      onBlur={handleChange}
                      label="Repair Description"
                      placeholder="Provide description..."
                      required
                      error={touched.repairDescription ? errors.repairDescription : undefined}
                      helperText={touched?.repairDescription ? errors.repairDescription : undefined}
                      classes="rounded"
                    />
                  </div>
                </div>
              </div>

              <div className="w-full flex gap-4 !mt-8">
                <Button
                type="button"
                label="Cancel"
                onClick={onClose}
                bgColor='secondary'
                  fullWidth
                
                />
                <Button
                label="Save"
                  onClick={handleSubmit}
                bgColor='primary'
              fullWidth
                disabled={loading}
                loading={loading}
                />
              </div>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default EditLead;
